import Marquee from "react-fast-marquee";
import { Star, Clock, Award, MapPin } from "lucide-react";

const MarqueeRibbon = () => {
  const items = [
    { icon: Award, text: "Medicina Dentária Avançada" },
    { icon: Clock, text: "Urgências 10h-19h" },
    { icon: Star, text: "Equipa Especializada" },
    { icon: MapPin, text: "Viseu" },
    { icon: Star, text: "Avaliação 5.0" },
    { icon: Award, text: "Implantologia" },
    { icon: Award, text: "Ortodontia" },
    { icon: Award, text: "Estética Dentária" },
  ];

  return (
    <div
      className="bg-gray-100 py-4 border-y border-gray-200"
      data-testid="marquee-ribbon"
    >
      <Marquee gradient={false} speed={40} pauseOnHover>
        {items.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-2 mx-8"
          >
            <item.icon className="w-4 h-4 text-[#1A1A1A]" />
            <span className="font-manrope font-medium text-[#4A4A4A]">
              {item.text}
            </span>
            <span className="text-[#8A8A8A] mx-4">•</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeRibbon;
